export default __webpack_public_path__ + "static/media/skewed-rectangle-blue-gradient.535d066d.svg";